var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "12px",
    viewBox: "0 0 24.0 12.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440,0 L1440,4174 L0,4174 L0,0 L1440,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5996371,0 L15.5996371,3.59963713 L24,3.59963713 L24,8.40036287 C23.9987904,9.06078016 23.4605383,9.59903236 22.800121,9.60024191 L22.800121,4.79951618 L14.3997581,4.79951618 L14.3997581,1.19987904 L10.5920774,1.19987904 C10.2727548,1.19987904 9.96794678,1.32688237 9.74296946,1.55185969 L7.15452071,4.14151799 C6.7880254,4.50801331 6.31387965,4.74629574 5.80102812,4.82007862 L2.22800121,5.33776837 C1.63652858,5.42243725 1.19987904,5.929241 1.19987904,6.5243423 L1.19987904,8.40036287 L2.72391896,8.40036287 C3.13879649,7.68309646 3.91170245,7.20048382 4.79951618,7.20048382 C5.68732991,7.20048382 6.46144542,7.68309646 6.87632295,8.40036287 L17.123677,8.40036287 C17.5385546,7.68309646 18.3126701,7.20048382 19.2004838,7.20048382 C20.5261566,7.20048382 21.5990324,8.2745691 21.5990324,9.60024191 C21.5990324,10.9259147 20.5261566,12 19.2004838,12 C17.8736015,12 16.8007257,10.9259147 16.8007257,9.60024191 L7.19927427,9.60024191 C7.19927427,10.9259147 6.12397944,12 4.79951618,12 C3.47384336,12 2.39854853,10.9259147 2.39854853,9.60024191 L0,9.60024191 L0,6.5678863 C0,5.38010281 0.868460841,4.37133353 2.04172966,4.19473843 L5.6087088,3.65890535 C5.86271545,3.62019958 6.09615966,3.50166314 6.27759298,3.32022982 L8.89628062,0.702751739 C9.34744481,0.252797097 9.95706078,0 10.5944965,0 L15.5996371,0 Z M19.2004838,8.40036287 C18.5364379,8.40036287 18.0006048,8.9374055 18.0006048,9.60024191 C18.0006048,10.2630783 18.5364379,10.800121 19.2004838,10.800121 C19.8633202,10.800121 20.3991533,10.2630783 20.3991533,9.60024191 C20.3991533,8.9374055 19.8633202,8.40036287 19.2004838,8.40036287 Z M4.79951618,8.40036287 C4.13667977,8.40036287 3.59963713,8.9374055 3.59963713,9.60024191 C3.59963713,10.2630783 4.13667977,10.800121 4.79951618,10.800121 C5.46235259,10.800121 5.99939522,10.2630783 5.99939522,9.60024191 C5.99939522,8.9374055 5.46235259,8.40036287 4.79951618,8.40036287 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-275.0 -1303.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(131.0 1264.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(144.0 33.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 6.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 24,0 24,12 0,12 0,0",
    stroke: "none",
    fill: "#000000"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/Truck.62ae823a27f1adbde8d481845320389e.svg";
export { ForwardRef as ReactComponent };